import { StyleSheet, Dimensions, Platform } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';
import { isIPhoneDeviceWithNotch } from '@vfgroup-oneplatform/foundation/Utils/Platform';

const { width: screenWidth, height: screenHeight } = Dimensions.get('window');

const isIPhoneWithNotch = isIPhoneDeviceWithNotch();

export default StyleSheet.create({
  backdrop: {
    position: 'absolute',
    backgroundColor: Colors.overlay,
    bottom: 0,
    width: screenWidth,
    height: screenHeight,
  },
  headerStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 15.6,
    paddingTop: Platform.OS === 'ios' && isIPhoneWithNotch ? 57 : 25,
  },
  innderBackOverlay: {
    flex: 1,
  },
  modalContent: {
    flex: 1,
  },
  modalStyle: {
    bottom: 0,
    position: 'absolute',
    width: screenWidth,
    zIndex: 2,
  },
  titleStyle: theme => ({
    color: theme.colors.textColorTwo,
    fontFamily: Fonts.type.VFFont,
    fontSize: 16.6,
    fontWeight: 'bold',
    letterSpacing: 0,
    lineHeight: 22,
  }),
});
